import { FC, memo, useCallback, useState } from 'react'

import { FilterContainer } from './styles'
import FilterContent from './content'
import FilterHeader from './header'
import { FilterTransport } from '../../../../transports/filters-configuration-transport'
import { FilterSectionTransport } from '../../../../transports/search-result-listing-static-transport'

interface Props {
    filter: FilterTransport
    filterStaticData: FilterSectionTransport
    shouldCommit?: boolean
}

const Filter: FC<Props> = ({ filter, filterStaticData, shouldCommit = false }) => {
    const [isOpen, setIsOpen] = useState(true)

    const handleToggle = useCallback(() => {
        setIsOpen(prev => !prev)
    }, [])

    return (
        <FilterContainer>
            <FilterHeader
                filterTitle={filter.title}
                filterType={filter.type}
                isActive={isOpen}
                onToggle={handleToggle}
            />
            {isOpen && (
                <FilterContent
                    filterType={filter.type}
                    filter={filter}
                    filterStaticData={filterStaticData}
                    shouldCommit={shouldCommit}
                />
            )}
        </FilterContainer>
    )
}

export default memo(Filter)
